import { MetricInfoModel } from '@logz-pkg/models';

export const UTS_SUMMARY_PAGE_SIZE = 500;

/**
 * Ceiling on how far the client will page while summing — the service has no totals endpoint yet
 * (APPZ-3362). An account with more than UTS_SUMMARY_MAX_PAGES * UTS_SUMMARY_PAGE_SIZE metrics
 * reports a lower bound rather than paging without limit.
 */
export const UTS_SUMMARY_MAX_PAGES = 40;

/** Pages are fetched in batches so the summary cannot starve the table's own request of connections. */
export const UTS_SUMMARY_PAGE_CONCURRENCY = 5;

export const UTS_SUMMARY_TOP_METRICS = 10;

export type UtsTopMetric = Pick<MetricInfoModel, 'metricName' | 'cardinality'>;

export interface IUtsSummary {
  totalUts: number;
  metricCount: number;
  topMetrics: UtsTopMetric[];
  /**
   * The true total is higher than `totalUts` — either a metric's cardinality was capped by the
   * m3db returned-series limit, or fewer metrics were summed than the service reported.
   */
  isLowerBound: boolean;
}

interface ISummarizeUtsParams {
  metrics: MetricInfoModel[];
  metricCount: number;
}

export const summarizeUts = ({ metrics, metricCount }: ISummarizeUtsParams): IUtsSummary => ({
  totalUts: metrics.reduce((sum, metric) => sum + metric.cardinality, 0),
  metricCount,
  topMetrics: [...metrics]
    .sort((a, b) => b.cardinality - a.cardinality)
    .slice(0, UTS_SUMMARY_TOP_METRICS)
    .map(({ metricName, cardinality }) => ({ metricName, cardinality })),
  isLowerBound: metrics.length < metricCount || metrics.some(metric => metric.metadata.approximateCardinality),
});
